import React, { Component } from "react";
import Header from "../../components/header/Header";
import "./BlogComponent.css";
import { articles, publications, publicationsHeader } from "../../portfolio";
import PublicationCard from "../../components/publicationsCard/PublicationCard";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import BlogsImg from "../contact/BlogsImg";
import "../blog/BlogComponent.css";
import PublicationCardLink from "../../components/publicationsCard/PublicationCardLink";

class Blog extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="projects-main">
        <Header theme={theme} />
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <BlogsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {publicationsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {publicationsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        {/* Publications  */}
        <div className="repo-cards-div-main">
          {publications.data.map((pub) => {
            return <PublicationCard pub={pub} theme={theme} />;
          })}
        </div>
        <div className="repo-cards-div-main">
          {articles.data.map((pub) => {
            return <PublicationCardLink pub={pub} theme={theme} />;
          })}
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Blog;
